import React from 'react';
import Svg, { Path } from 'react-native-svg';

export interface BackspaceIconProps {
  /** Can be used to change the color of the icon. */
  iconColor?: string;

  /** The size of the icon */
  iconSize: number;

  /** The accessibility label for the backspace icon. */
  iconAccessibilityLabel?: string;
}

export default function Backspace({ iconColor, iconSize }: BackspaceIconProps) {
  return (
    <Svg
      width={iconSize}
      height={(iconSize * 56) / 125} // Maintain aspect ratio
      viewBox="0 0 125 56"
      fill="none"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.8221 20C57.6278 20 57.4465 20.092 57.3387 20.2451L52.0976 27.6947C51.9675 27.8796 51.9675 28.1204 52.0976 28.3053L57.3387 35.7549C57.4465 35.908 57.6278 36 57.8221 36H74.4191C74.7399 36 75 35.7536 75 35.4496V20.5504C75 20.2464 74.7399 20 74.4191 20H57.8221ZM70.1189 32.0233L67 28.9044L63.8811 32.0233L63.0478 31.1899L66.1667 28.0711L63.0478 24.9522L63.8811 24.1189L67 27.2377L70.1189 24.1189L70.9522 24.9522L67.8333 28.0711L70.9522 31.1899L70.1189 32.0233Z"
        fill={iconColor}
      />
    </Svg>
  );
}
